<div>[{{ note.createdAt | date: 'MM/dd/yyyy'}} {{ note.username }}] <span class="phi" [innerHtml]="note.safeHtmlContent | safeHtml"></span></div>